var storefrontApp = angular.module('storefrontApp');

storefrontApp.directive('vcContentPlace', ['$compile', 'marketingService', function ($compile, marketingService) {
    return {
        restrict: 'E',
        link: function (scope, element, attrs) {
            marketingService.getDynamicContent(attrs.id).then(function (response) {
                element.html($compile(response.data)(scope));
            });
        },
        replace: true
    }
}]);

storefrontApp.directive('fallbackSrc', function () {
    return {
        link: function (scope, element, attrs) {
            element.on('error', errorHandler);

            scope.$on('$destroy', function() {
                element.off('error', errorHandler);
            });

            function errorHandler(event) {
                if (element.attr('src') !== attrs.fallbackSrc) {
                    element.attr('src', attrs.fallbackSrc);
                }
                else {
                    element.off(event);
                }
            };
        }
    }
});

// https://stackoverflow.com/questions/19333544/skip-nested-forms-validation-with-angularjs
storefrontApp.directive('isolateForm', function () {
    return {
        restrict: 'A',
        require: '?form',
        link: function (scope, element, attrs, formController) {
            if (!formController) {
                return;
            }

            var parentForm = formController.$$parentForm; // Note this uses private API
            if (!parentForm) {
                return;
            }

            // Remove this form from parent controller
            parentForm.$removeControl(formController);
        }
    };
});

// https://codepen.io/giovani_araujo/pen/jPGXNo
storefrontApp.directive('date', function (dateFilter) {
    return {
        restrict: 'A',
        require:'ngModel',
        link: function (scope, elm, attrs, ctrl) {

            var dateFormat = attrs['date'] || 'MM/dd/yyyy';
           
            ctrl.$formatters.unshift(function (modelValue) {
                return dateFilter(modelValue, dateFormat, 'UTC');
            });
        }
    };
});